import React from 'react';
import { Grid, TextField } from '@mui/material';
import { UtilityService } from '../../../types/utility.types';

interface WaterFormProps {
  formData: UtilityService;
  handleFormChange: (field: string, value: any) => void;
  handleNestedChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isViewMode: boolean;
}

/**
 * Component for Water contracts
 */
const WaterForm: React.FC<WaterFormProps> = ({
  formData,
  handleFormChange,
  handleNestedChange,
  isViewMode,
}) => {
  return (
    <Grid container spacing={3}>
      {/* SPID */}
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          label="SPID"
          name="meterDetails.meterType"
          value={formData.meterDetails?.meterType || ''}
          onChange={handleNestedChange}
          disabled={Boolean(isViewMode)}
          required
        />
      </Grid>
      
      {/* Meter Serial Number */}
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          label="Meter Serial Number"
          name="meterDetails.serialNumber"
          value={formData.meterDetails?.serialNumber || ''}
          onChange={handleNestedChange}
          disabled={Boolean(isViewMode)}
        />
      </Grid>
      
      {/* Discount against DST */}
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          label="Discount against DST"
          name="currentRate"
          value={formData.currentRate || ''}
          onChange={(e) => handleFormChange('currentRate', e.target.value)}
          disabled={Boolean(isViewMode)}
          helperText="Default Standard Tariff discount"
          required
        />
      </Grid>
      
      {/* Contract Value */}
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          label="Contract Value"
          name="contractValue"
          value={formData.contractValue || ''}
          onChange={(e) => {
            // Only allow numbers and decimal point
            const value = e.target.value;
            if (value === '' || /^\d*\.?\d{0,2}$/.test(value)) {
              handleFormChange('contractValue', value);
            }
          }}
          disabled={Boolean(isViewMode)}
          InputProps={{
            startAdornment: <span style={{ marginRight: '4px' }}>£</span>,
          }}
          helperText="Enter contract value in pounds"
          required
        />
      </Grid>
    </Grid>
  );
};

export default WaterForm;
